import {OverlayTrigger, Tooltip} from "react-bootstrap";
import React from "react";
import C from "helpers/HelpConstants";
import {HelpAbility} from "helpers/HelpAbility";

const UserCrudTableRow = ({
                              user,
                              setDataToEditAndShowModal,
                              setDataToUpdatePassAndShowModal,
                              setDataToUpdateAbilitiesAndShowModal,
                              deleteData
                          }) => {
    let {names, paternalSurname, maternalSurname, email, _id, rol} = user;
    let myAbilities = HelpAbility();
    return (
        <tr>
            <td>{`${names}`}</td>
            <td>{`${paternalSurname}`}</td>
            <td>{`${maternalSurname}`}</td>
            <td>{email}</td>
            <td>
                <ul className="m-0">
                    {rol.map(ro => (
                        <li key={ro} className="">{`${ro[0].toUpperCase()}${ro.slice(1)}`}</li>
                    ))}
                </ul>            
            </td>
            {myAbilities.hasAny([C.A.USER.UPDATE, C.A.USER.UPDATE_PASS, C.A.USER.UPDATE_ABIL, C.A.USER.DELETE]) &&
            <td className="text-center">
                {myAbilities.has(C.A.USER.UPDATE) &&
                <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Editar</Tooltip>}>
                    <button type="button" className="btn btn-sm btn-success me-1 mt-lg-0 mt-md-1 mt-sm-1 mt-1"
                            onClick={() => setDataToEditAndShowModal(user)}>
                        <i className="bi bi-pencil-square"/></button>
                </OverlayTrigger>}
                {myAbilities.has(C.A.USER.UPDATE_PASS) &&
                <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Editar Contraseña</Tooltip>}>
                    <button type="button" style={{color: 'white'}} className="btn btn-sm btn-warning me-1 mt-lg-0 mt-md-1 mt-sm-1 mt-1"
                            onClick={() => setDataToUpdatePassAndShowModal(user)}>
                        <i className="bi bi-key"/></button>
                </OverlayTrigger>}
                {myAbilities.has(C.A.USER.UPDATE_ABIL) &&
                <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Editar Autorizaciones</Tooltip>}>
                    <button type="button" className="btn btn-sm btn-secondary me-1 mt-lg-0 mt-md-1 mt-sm-1 mt-1"
                            onClick={() => setDataToUpdateAbilitiesAndShowModal(user)}>
                        <i className="bi bi-file-lock"/></button>
                </OverlayTrigger>}
                {/*my-md-4 my-sm-3 my-3*/}
                {myAbilities.has(C.A.USER.DELETE) &&
                <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Eliminar</Tooltip>}>
                    <button type="button" className="btn btn-sm btn-danger me-1 mt-lg-0 mt-md-1 mt-sm-1 mt-1" onClick={() => deleteData(_id)}>
                        <i className="bi bi-trash"/></button>
                </OverlayTrigger>}
            </td>}
        </tr>
    );
}
export default UserCrudTableRow;
